import { VOLUUM_URL } from 'consts/api';
import VoluumModel from 'models/voluum.model';
import services from 'services';

class VoluumService {
  getVoluumData() {
    return services.get(VOLUUM_URL);
  }

  toggleStatus(active) {
    return services.post(`${VOLUUM_URL}/enable?active=${active}`);
  }

  updateVoluumSetting(
    body = {
      phone: '',
      campaignName: '',
      did: '',
      domain: '',
      creative: '',
      route: '',
      messageId: '',
    }
  ) {
    return services.post(VOLUUM_URL, VoluumModel.parseRequestUpdate(body));
  }

  updateVoluumCredential(
    body = {
      accessId: '',
      accessKey: '',
      active: true,
    }
  ) {
    return services.post(`${VOLUUM_URL}/credential`, body);
  }
}

export default new VoluumService();
